import MixpanelService from "../services/mixpanel";

const HTTP_STATUS_UNKNOWN = -1;
const ERROR_CODE_UNKNOWN = -1;
const MESSAGE_UNKNOWN = -1;

function resourcesUtil() {
  const basePath = "";

  const instance = window.axios.create({
    baseURL: "",
    timeout: 30000
  });

  const instanceCard = window.axios.create({
    baseURL: "",
    timeout: 30000
  });

  instance.interceptors.request.use(
    function(config) {
      //TODO: Read from store
      const token = localStorage.getItem("token");
      if (token && !config.headers["disableAuthorization"]) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      if (!config.headers.deviceId) {
        delete config.headers.deviceId;
      }
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      //TODO: Read from store
      if (
        error.response.status === 401 &&
        window.location.pathname !== "/login"
      ) {
        MixpanelService.reset();
        localStorage.removeItem("token");
        //TODO: use the store instead sessionStorage
        window.location = "/login";
      } else {
        return Promise.reject(error);
      }
    }
  );

  instanceCard.interceptors.request.use(
    function(config) {
      //TODO: Read from store
      const token = localStorage.getItem("token");
      if (token && !config.headers["disableAuthorization"]) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      if (!config.headers.deviceId) {
        delete config.headers.deviceId;
      }
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  instanceCard.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      //TODO: Read from store
      if (
        error.response.status === 401 &&
        window.location.pathname !== "/login"
      ) {
        MixpanelService.reset();
        localStorage.removeItem("token");
        //TODO: use the store instead sessionStorage
        window.location = "/login";
      } else {
        return Promise.reject(error);
      }
    }
  );

  return {
    deviceId: null,
    init(baseUrl, deviceId) {
      instance.defaults.baseURL = baseUrl + basePath;
      instance.defaults.headers.deviceId = deviceId;
    },
    initCard(baseUrl, deviceId) {

      if(baseUrl !==null) {
        instanceCard.defaults.baseURL = baseUrl + basePath;
      } else {
        instanceCard.defaults.baseURL = instance.defaults.baseURL;
      }
      instanceCard.defaults.headers.deviceId = deviceId;
    },
    createErrorWithHttpStatus(error) {
      return {
        httpStatus: (error && error.response && error.response.status)
          ? error.response.status
          : HTTP_STATUS_UNKNOWN,
        code:
          (error && error.response && error.response.data && error.response.data.code)
            ? error.response.data.code
            : ERROR_CODE_UNKNOWN
      };
    },
    createErrorWithHttpStatusAndMessage(error) {
      return {
        httpStatus: (error && error.response && error.response.status)
          ? error.response.status
          : HTTP_STATUS_UNKNOWN,
        code:
          (error && error.response && error.response.data && error.response.data.code)
            ? error.response.data.code
            : ERROR_CODE_UNKNOWN,
        message:
          (error && error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : MESSAGE_UNKNOWN
      };
    },
    get: instance.get,
    post: instance.post,
    put: instance.put,
    getCard: instanceCard.get,
    postCard: instanceCard.post,
    putCard: instanceCard.put,
    getPci: instanceCard.get,
    postPci: instanceCard.post,
    putPci: instanceCard.put,
  };
}

export default resourcesUtil();



// WEBPACK FOOTER //
// ./src/utils/resourcesUtil.js